import { useApi, useToaster } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { watchEffect } from "vue";

export function usePackagedServices() {
  const api = useApi();
  
  const { isLoading, error, data } = useQuery({
    queryKey: ["expert", "packagedServices"],
    queryFn: () => api.expert.getPackagedServices(),
    retry: 2,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  const toaster = useToaster();

  watchEffect(() => {
    if (error.value) {
      toaster.create({ title: "Failed to load packaged services", type: "error" });
      console.error(error.value);
    }
  });

  return { isLoading, error, data };
}

export default usePackagedServices;
